<template>
  <div class="container">
    <div class="row">

      <div class="col-md-4">
        <div class="row h-100">

          <div class="col-12 d-flex">
            <b-card class="text-center w-100 d-flex flex-column justify-content-center">
              <i class="fas fa-users mb-1 text-icon"></i>
              <h1 class="text-orange">{{ header.total || 0 }}</h1>
              <p class="card-label">Lista total</p>
            </b-card>
          </div>
        </div>
      </div>

      <div class="col-md-5">
        <div class="row">

          <div class="col-md-6">
            <b-card class="text-center small-card">
              <h1>{{ header.pf || 0 }}</h1>
             <p class="card-label">Lista PF</p>
            </b-card>
          </div>

          <div class="col-md-6 ">
            <b-card class="text-center small-card">
              <h1>{{ header.pj || 0 }}</h1>
              <p class="card-label">Lista PJ</p>
            </b-card>
          </div>

          <div class="col-md-6">
            <b-card class="text-center small-card">
              <h1>{{ header.viainvest || 0 }}</h1>
              <p class="card-label">Cadastro Vialnvest</p>
            </b-card>
          </div>

          <div class="col-md-6">
            <b-card class="text-center small-card">
              <h1>{{ header.soulpay || 0 }}</h1>
              <p class="card-label">Cadastro Soulpay</p>
            </b-card>
          </div>

        </div>
      </div>

      <div class="col-md-3">
       <BlackListActions
        :canManage="canManage"
        @open-add-modal="$emit('open-add-modal')" 
        @open-bulk-modal="$emit('open-bulk-modal')"
        @open-delete-modal="$emit('open-delete-modal')"
      />
      </div>

    </div>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import BlackListActions from "@/views/pages/Blacklist/BlacklistActions.vue"; 

export default {
  components: {
    BCard,
    BlackListActions
  },
  props: {
    header: {
      type: Object,
      default: () => ({})
    },
    canManage: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.small-card {
  padding: 6px !important;
  border-left: 4px solid var(--primary);
}

.text-orange {
  color: #f37021;
  font-weight: bold;
  font-size: 90px;
}

.text-icon {
  margin-top: 15px;
  color: #f37021;
  font-weight: bold;
  font-size: 40px;
}

.card-label {
  font-size: 16px;
  margin: 0;
  color: #666; 
}
</style>